import { Map } from 'immutable';
import createCachedSelector from 're-reselect';

import { ReduxState } from 'app/redux/types';

import { BettingEntitiesSelectors, RecordOfStakeEntity } from 'app/lib/betting/betting-entities';

const emptyMap = Map<number, RecordOfStakeEntity>();

export default (matches: BettingEntitiesSelectors['matches']) => {
  return createCachedSelector(
    (state: ReduxState, matchId: number) => matches(state).get(matchId),
    (match) => {
      if (!match) {
        return emptyMap;
      }

      return match.stakes.reduce((map, stake) => {
        return map.set(stake.id, stake);
      }, emptyMap);
    },
  )((_state, matchId) => matchId);
};
